import React, { useEffect, useState } from 'react'
import { AppLoader } from '@portal/kit/pkg/components'
import { useTranslation } from 'react-i18next'

export default function Support() {
  const { i18n } = useTranslation()
  const [displayLoader, setDisplayLoader] = useState(true)

  useEffect(() => {
    setTimeout(() => setDisplayLoader(false), 5000)
  }, [])

  if (!displayLoader) {
    return null
  }

  return (
    <>
      <p style={{textAlign: 'center'}}>{i18n.t('support.loading')}</p>
      <AppLoader />
    </>
  )
}
